const INITIAL_STATE = {
  data: {},
  errors: {},

}
const getUserDetails = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_USERS_DETAIL_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_USERS_DETAIL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state, ...INITIAL_STATE }
  }
};

export default getUserDetails;